export default __webpack_public_path__ + "static/media/demo4.9eb49be0.jpg";